import Component from '@bythepixel/component-loader';

export default class FilterInput extends Component {
  static selector = '[comp-filter-input]'

  constructor(...args) {
    super(...args);
    this.query = '';
    this.filterables = [];
    this.$container.value = new URLSearchParams(window.location.search).get('location-search');
    this.events();
    this.updateQuery(this.$container.value);
  }

  events() {
    this.$container.addEventListener('change', () => {
      this.updateQuery(this.$container.value);
    });
  }

  updateQuery(query) {
    this.query = query;
    this.$publish('filter-query', { query });
    this.$publish('fit-bounds', { query });
  }

  getQuery() {
    return this.query;
  }
}
